import script from "./UserReview.vue?vue&type=script&setup=true&lang=js"
export * from "./UserReview.vue?vue&type=script&setup=true&lang=js"

import "./UserReview.vue?vue&type=style&index=0&id=b0a232ba&lang=css"

const __exports__ = script;

export default __exports__